import * as d3 from "d3";
import { sortByTypes, nodeTypes } from "@/assets/configStrings.js";

export default function (
  resultsForSankey1,
  resultsForSankey2,
  pending1,
  pending2,
  donorId,
  donorName,
  sortingHeaders,
  groupSmallContributions
) {
  /*

const headers =[
  {text: "Donors", sortBy: sortByTypes.Auto,  } ...
  */
  if (groupSmallContributions === undefined) groupSmallContributions = true;

  const nodesWithLowPercentage = computed(() => {
    const THRESHOLD = 1; // set the threshold for low contributions (percentage)
    const percentageByRecipient = d3.rollups(
      resultsForSankey1.value,
      (v) => {
        return {
          percentage: d3.sum(v, (d) => d.percentage),
          TOTAL: d3.sum(v, (d) => d.TOTAL),
        };
      },
      (d) => d._id[0]
    );
    // get the list of recipients with a low percentage
    const lowContributions = Array.from(percentageByRecipient)
      .filter((item) => item[1].percentage < THRESHOLD)
      .map((item) => {
        return { id: item[0], percentage: item[1].percentage, TOTAL: item[1].TOTAL };
      });
    return lowContributions;
  });

  const nodesWithLowPercentageArray = computed(() => {
    return nodesWithLowPercentage.value.map((item) => item.id);
  });

  const resultsForSankey1WithOthers = computed(() => {
    // dataRecipients.value.documents contains an array of object. Each object contains a _id and a TOTAL. The _id is a pair of [recipientId, categoryId]
    // there are to many countries. Wee need to create an extra category called "other" and group all the countries with a low number of donations in it Below a threeshold
    // BEGIN: low-contributions

    // create a new array identical to dataRecipients.value.documents but grouping the low contributions in a new category called "other"
    const dataRecipientsWithOther = resultsForSankey1.value.map((item) => {
      if (nodesWithLowPercentageArray.value.includes(item._id[0])) {
        return {
          _id: ["Others", item._id[1]],
          label: "Others",
          originalLabel: item._id[0],
          TOTAL: item.TOTAL,
          percentage: item.percentage,
        };
      } else {
        return { ...item };
      }
    });
    return dataRecipientsWithOther;
  });

  // const resultsForSankey2 = computed(() => {
  //   if(pending2.value) return [];
  //   console.log(JSON.stringify(dataCategoriesDonor.value.documents))
  //   return dataCategoriesDonor.value.documents;
  // });

  const allLinks = computed(() => {
    let links = [];
    if (pending1.value || pending2.value) return links;
    resultsForSankey2.value.forEach((item) => {
      links.push({
        source: donorId.value,
        target: item._id,
        value: item.TOTAL,
        id: donorId.value + "-" + item._id,
      });
    });

    resultsForSankey1WithOthers.value.forEach((item) => {
      links.push({
        source: item._id[1],
        target: item._id[0],
        value: item.TOTAL,
        id: item._id[1] + "-" + item._id[0],
      });
    });
    return links;
  });

  // min height should be the number of recipients * 20

  // list of nodes
  const allRecipients = computed(() => {
    const allRecipientsMap = d3.rollup(
      resultsForSankey1WithOthers.value,
      (v) => {
        return { TOTAL: d3.sum(v, (d) => d.TOTAL), label: v[0].label };
      },
      (d) => d._id[0]
    );

    // let rec = resultsForSankey1WithOthers.value.map((item) => {
    //   return {
    //     _id: item._id[0],
    //   };
    // });
    const a = Array.from(allRecipientsMap, ([code, totalAndLabel]) => ({
      _id: code,
      name: totalAndLabel.label,
      TOTAL: totalAndLabel.TOTAL,
      type: nodeTypes.recipient,
    })).sort(sortFunctions[sortingHeaders.value[2].sortBy]);
    return a;
  });

  const allCategoriesThisDonor = computed(() => {
    const allCategoriesMap = d3.rollup(
      resultsForSankey2.value,
      (v) => d3.sum(v, (d) => d.TOTAL),
      (d) => d._id
    );
    // iterate over the map and return an array of objects
    return Array.from(allCategoriesMap, ([name, value]) => ({
      _id: name,
      name: name,
      TOTAL: value,
      type: nodeTypes.category,
    })).sort(sortFunctions[sortingHeaders.value[1].sortBy]);
  });

  const allNodes = computed(() => {
    let nodes = [
      {
        _id: donorId.value,
        name: donorName.value,
        TOTAL: 0,
        type: nodeTypes.donor,
      },
    ];
    nodes = nodes.concat(allRecipients.value);
    nodes = nodes.concat(allCategoriesThisDonor.value);
    return nodes.map((node) => {
      return {
        id: node._id,
        name: node.name,
        value: node.TOTAL,
        type: node.type,
      };
    });
  });

  const sankeyData = computed(() => {
    return {
      nodes: allNodes.value,
      links: allLinks.value,
    };
  });
  const isDataForSankeyReady = computed(() => {
    return (
      sankeyData.value.nodes.length > 0 &&
      sankeyData.value.links.length > 0 &&
      allCategoriesThisDonor.value.length > 0 &&
      allRecipients.value.length > 0 &&
      pending1.value === false &&
      pending2.value === false
    );
  });

  const sortFunctions = {
    [sortByTypes.Auto]: (a, b) => true,
    [sortByTypes.Name]: (a, b) => d3.ascending(a._id, b._id),
    [sortByTypes.Value]: (a, b) => d3.ascending(a.TOTAL, b.TOTAL),
  };

  return {
    sankeyData,
    isDataForSankeyReady,
    allCategoriesThisDonor,
    allRecipients,
    allNodes,
    allLinks,
    resultsForSankey1WithOthers,
    nodesWithLowPercentage,
  };
}
